import Base from "../Base";
import {LastMessage} from "./LastMessage";
import {colorById} from "../../helpers/ColorHelper";
import Message from "../Messages/Message";
import {DateTime} from "luxon";

export class Room extends Base{
    title;
    subtitle;
    ownerId;
    groupId;
    type;
    lastMessage = null;
    notifications;
    userId;
    isMember;
    membersCount;
    isHidden;
    isUserDeleted;
    unreadCount;
    id;
    createdAt;
    updatedAt;
    isDeleted;
    isPublished;
    updatedBy;

    dates = ['updatedAt', 'createdAt'];
    integers = ['userId'];

    constructor(data) {
        super();
        this.setUp(this, data);
        if (this.lastMessage) {
            this.lastMessage = new Message(this.lastMessage);
        }
    }

    color() {
        return colorById(this.id);
    }

    date() {
        let format = 'dd.MM',
            date = null;
        if (this.lastMessage &&  this.lastMessage.createdAt)  {
            date = this.lastMessage.createdAt;
        }
        else if (this.updatedAt) {
            date = this.updatedAt;
        }
        if (date) {
            if (date.year != DateTime.local().year) {
                format = 'dd.MM.yy';
            }
            if (date.toFormat('dd.MM.yy') == DateTime.local().toFormat('dd.MM.yy')) {//today
                format = 'HH:mm';
            }
            return date.toFormat(format);
        }
        return '';
    }

    message() {
        if (this.lastMessage && this.lastMessage.message) {
            return this.lastMessage.message;
        }
        return this.subtitle || '';
    }
}